/**
 * 
 * key
 * 
 */


const key = 'ZGVsaXZlcmFibGVfZm9sbG93dXBfcmVhc29u'

export default key 